/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import EditPromptCard from '../items/EditPromptCard'

import { positionChangeWidthSm, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { Input } from '../../../../helpers/globalHelpers'
import { modifyDatingProfileInDatabase } from '../../../../helpers/modifyInDatabase'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const editPromptsJSX = (
  isDemo,
  user, setUser,
  datingProfile, setDatingProfile,
  previousDatingProfile, setPreviousDatingProfile,
  selectedPromptIndex, setSelectedPromptIndex,
  newPrompt, setNewPrompt,
  openPromptSelectModal, setOpenPromptSelectModal,
  customPromptSelected, setCustomPromptSelected,
  openMediaItemSelectModal, openAboutMeSelectModal, openHobbySelectModal,
  loading, setLoading,
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  const promptIndexesArray = [0, 1, 2]

  const tapDisabled = () => {
    return (
      openPromptSelectModal 
      || openAboutMeSelectModal 
      || openHobbySelectModal
      || loading.loading
      || loading.mediaItems
      || loading.aboutMe
      || loading.prompts
      || loading.hobbies
      || loading.selectMediaItem
      || loading.selectAboutMe
      || loading.selectPrompt
      || loading.selectHobby
    )
  }

  const showSaveAndCancelButtons = () => {
    // console.log('keys > 0', Object.keys(datingProfile).length > 0)
    // console.log('bio in profile', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile)
    // // console.log('datingProfile.bio ->', datingProfile.bio)
    // console.log('prompts in bio', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile && 'prompts' in datingProfile.bio)
    // console.log('profile prompts length ->', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile && 'prompts' in datingProfile.bio ? datingProfile.bio : false)
    // console.log('previous prompts length ->', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile && 'prompts' in datingProfile.bio ? previousDatingProfile.bio.prompts : false)
    // console.log('length = previous ->', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile && 'prompts' in datingProfile.bio && datingProfile.bio.prompts.length === previousDatingProfile.bio.prompts.length)
    // console.log('indexes differ ->', Object.keys(datingProfile).length > 0 && 'bio' in datingProfile && 'prompts' in datingProfile.bio && datingProfile.bio.prompts.length === previousDatingProfile.bio.prompts.length && datingProfile.bio.prompts.filter((item, itemIndex) => ((item.prompt !== previousDatingProfile.bio.prompts[itemIndex].prompt) || (item.response !== previousDatingProfile.bio.prompts[itemIndex].response))).length === 0 )

    return !(
      Object.keys(datingProfile).length > 0
      && 'bio' in datingProfile
      && 'prompts' in datingProfile.bio
      && datingProfile.bio.prompts.length === previousDatingProfile.bio.prompts.length
      && 
        datingProfile.bio.prompts.filter((item, itemIndex) => 
          (
            (itemIndex > previousDatingProfile.bio.prompts.length)
            || (item.prompt !== previousDatingProfile.bio.prompts[itemIndex].prompt) 
            || (item.response !== previousDatingProfile.bio.prompts[itemIndex].response)
          )
        ).length === 0 
    )
  }

  const handleSelectItem = (e, selectedIndex) => {
    console.log('handleSelectItem runs')
    e.preventDefault()
    if (
      !(
        tapDisabled()
      )
    ) {
      resetLoadingAndErrors()
      resetSaveSuccessful()
      setSelectedPromptIndex(selectedIndex)

      // console.log('selected prompt ->', datingProfile.bio.prompts.length > selectedIndex ? datingProfile.bio.prompts[selectedIndex].prompt : '')
      // console.log('selected response ->', datingProfile.bio.prompts.length > selectedIndex ? datingProfile.bio.prompts[selectedIndex].response : '')
      setNewPrompt({
        ...newPrompt,
        prompt: datingProfile.bio.prompts.length > selectedIndex ? datingProfile.bio.prompts[selectedIndex].prompt : '',
        response: datingProfile.bio.prompts.length > selectedIndex ? datingProfile.bio.prompts[selectedIndex].response : '',
      })
      setOpenPromptSelectModal(true)
    }
  }

  const handleCancelPressed = () => {
    console.log('handleCancelPressed runs')
    // console.log('previousDatingProfile.prompts ->', previousDatingProfile.bio.prompts)
    const resetBio = {
      ...datingProfile.bio,
      prompts: [ ...previousDatingProfile.bio.prompts ],
    }
    // console.log('resetBio ->', resetBio)
    setDatingProfile({ ...datingProfile, bio: { ...resetBio } })
    resetSaveSuccessful()
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')

    const newBio = {
      ...previousDatingProfile.bio,
      prompts: datingProfile.bio.prompts,
    }

    if (isDemo) {

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })
      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
      })
      
      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })

    } else {
      const objectToUpload = {
        bio: { ...newBio },
      }
      // console.log('objectToUpload ->', objectToUpload)

      await modifyDatingProfileInDatabase(`prompts`, datingProfile._id, objectToUpload, errors, setErrors, loading, setLoading)

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        
        const threePromptsSorted = [ ...userDatingProfile.bio.prompts, ...datingProfile.bio.prompts ].filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).slice(0, 3)
        while (threePromptsSorted.length < 3) {
          threePromptsSorted.push({
            prompt: '',
            response: '',
          })
        }
        
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length >= 3
              ?
              userDatingProfile
              :
              {
                ...userDatingProfile,
                bio: {
                  ...userDatingProfile.bio,
                  prompts: [ ...threePromptsSorted ],
                },
              }
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })

      // Add default prompts to User if necessary
      const newUserBioObj = { ...user.bio }
      if (
        datingProfile.bio.prompts.length > 0
        && datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length > 0
        && 'prompts' in user.bio
        && user.bio.prompts !== null
        && Array.isArray(user.bio.prompts)
        && user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length < 6
      ) {
        if (
          user.bio.prompts.length === 0
          || user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length === 0
        ) {
          const filteredDatingProfilePrompts = datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0)
          const filteredCurrentPrompts = [ ...filteredDatingProfilePrompts ]

          while (filteredCurrentPrompts.length < 3) {
            filteredCurrentPrompts.push({
              prompt: '',
              response: '',
            })
          }

          newUserBioObj.prompts = [ ...filteredCurrentPrompts ].slice(0, 6)
        } else {

          const filteredCurrentPrompts = user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0)

          for (let i = 0; i < datingProfile.bio.prompts.length; i++) {
            if (
              filteredCurrentPrompts.length < 6
              && 'prompt' in datingProfile.bio.prompts[i]
              && datingProfile.bio.prompts[i].prompt.length > 0
              && 'response' in datingProfile.bio.prompts[i]
              && datingProfile.bio.prompts[i].response.length > 0
              && !(user.bio.prompts.filter(promptObj => (promptObj.prompt === datingProfile.bio.prompts[i].prompt) || (promptObj.response === datingProfile.bio.prompts[i].response)).length > 0)
            ) {
              filteredCurrentPrompts.push(datingProfile.bio.prompts[i])
            } 
          }

          while (filteredCurrentPrompts.length < 3) {
            filteredCurrentPrompts.push({
              prompt: '',
              response: '',
            })
          }

          newUserBioObj.prompts = [ ...filteredCurrentPrompts ].slice(0, 6)
        }
      }

      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
        bio: { ...newUserBioObj },
      })

      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })
      
    }
  }

  return (
    <Box
      sx={{
        py: 3, 
        mt: width < positionChangeWidthSm ? 2 : 2,
        mb: 2,
        width: width < positionChangeWidthSm ? '100%' : '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: width < positionChangeWidthSm ? 0 : 3, boxShadow: width < positionChangeWidthSm ? 3 : 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: width < positionChangeWidthSm ? '90%' : '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Prompts', 
          `*Tap to edit
          *Drag and drop to reorder`,
          0
        )}


        {/* Prompts */}
        <DndProvider backend={HTML5Backend}>
          {promptIndexesArray.map((promptIndex) => (
            <Box
              key={promptIndex}
              // onClick={(e) => handleSelectItem(e, promptIndex)}
              sx={{
                my: 1,
                width: '100%',
                backgroundColor: 'white',
                borderRadius: 3, boxShadow: 3,
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
              }}
            >
              {'bio' in datingProfile && datingProfile.bio !== null && Object.keys(datingProfile.bio).length > 0 && 'prompts' in datingProfile.bio && datingProfile.bio.prompts.length > promptIndex && datingProfile.bio.prompts[promptIndex].prompt.length > 0  && datingProfile.bio.prompts[promptIndex].response.length > 0
                ?
                <EditPromptCard promptItem={datingProfile.bio.prompts[promptIndex]} datingProfile={datingProfile} setDatingProfile={setDatingProfile} promptItemIndex={promptIndex} loading={loading} tapDisabled={tapDisabled} handleSelectItem={handleSelectItem} />
                :
                <Box
                  onClick={(e) => handleSelectItem(e, promptIndex)}
                  disabled={tapDisabled()}
                  sx={{
                    width: '100%',
                    backgroundColor: 'gray',
                    boxShadow: 3, 
                    borderRadius: '5px', 
                    cursor: tapDisabled() ? '' : 'pointer',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  <AddIcon 
                    color='primary'
                    sx={{
                      my: 1,
                      // boxShadow: 3, 
                      borderRadius: '50%',
                      border: 2, 
                      borderColor: 'black',
                      backgroundColor: 'white',
                      width: '35px', height: '35px',
                    }}
                  />
                </Box>
              }
              
            </Box>
          ))}
        </DndProvider>


        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons()
          && saveAndCancelButtonsJSX(
            loading.prompts,
            (!(showSaveAndCancelButtons()) || loading.prompts),
            handleCancelPressed,
            handleSavePressed,
            0,
            0,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loading.prompts &&
          advisoryTypography(`Uploading Changes...`)
        }

        {/* Error Message */}
        {errors.prompts &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.prompts &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}